import { KeyValueModel } from "@models/common";

export class AreaDetail {
    public id: number;
    public name: string;
    public legendKey: number;
    public totalPrograms: number;
}

export class AreaDetailWithData extends AreaDetail {
    public data: KeyValueModel[];
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/area-detail.ts